import { ApiResponse } from '@/utils';
import { enhancedRequest } from '@/utils/enhancedRequest';
import {
  CreateOrderParams,
  CreateOrderResponse,
  QueryOrderParams,
  QueryOrderResponse,
} from '../types';

/**
 * AMAI订单服务
 * 用于处理订单创建和查询
 */
class OrderService {
  /**
   * 创建订单
   * @param params 创建订单参数 { package_id }
   * @returns 订单创建结果，包含订单ID、下单时间、过期时间、支付金额、二维码链接
   */
  async createOrder(params: CreateOrderParams): Promise<ApiResponse<CreateOrderResponse>> {
    return enhancedRequest.post<CreateOrderResponse>('/order', params, {
      enableDeduplication: true,
      requestKey: `create-order:${params.package_id}`,
      retryCount: 0, // 订单创建不重试，避免600001等业务错误被重复请求
      timeout: 15000, // 订单创建15秒超时
    });
  }

  /**
   * 查询订单状态
   * @param params 查询订单参数 { order_id }
   * @returns 订单详情，包含订单ID、下单时间、过期时间、支付金额、二维码链接、支付状态
   */
  async queryOrder(params: QueryOrderParams): Promise<ApiResponse<QueryOrderResponse>> {
    return enhancedRequest.post<QueryOrderResponse>('/order/query', params, {
      enableDeduplication: true,
      requestKey: `query-order:${params.order_id}`,
      retryCount: 3,
      timeout: 10000, // 订单查询10秒超时
    });
  }
}

export default new OrderService();
